import React, { useState } from "react";
import CustomTable from "../../../commons/CustomTable";
import moment from "moment";
import { ExpandLess } from "../../../assets/svg/AllSvg";
import { Badge } from "../../../components/micro";

const PostSubscription = ({ past_subscriptions }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Table Data
  const salesList = {
    data: past_subscriptions,
  };

  // Table Heading
  const ColumnHeaders = () => {
    return (
      <>
        <th
          scope="col"
          className="px-5 py-3 table_responsive_text border-b font-semibold text-left bg-primary_shades_light whitespace-nowrap "
        >
          <div className="flex items-center space-x-2">
            <p>Past Subscription/Transaction</p>
            <Badge
              value={past_subscriptions?.length}
              className={
                "bg-danger_color border-danger_color text-white text-xs !px-2 !py-0.5"
              }
            />
          </div>
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Billing Cycle
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Period
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light "
        >
          <div className="flex items-center space-x-2 text-sm">
            <p>Hides</p>
            <button
              type="button"
              className={isOpen ? "rotate-0" : "rotate-180"}
              onClick={() => setIsOpen(!isOpen)}
            >
              <ExpandLess pathClass={"fill-secondary_lightGrey"} />
            </button>
          </div>
        </th>
      </>
    );
  };

  // Table Row
  const DataRows = () => {
    return (
      <>
        {(salesList?.data || [])?.map((element) => (
          <tr
            className={
              "border-b table_responsive_text hover:bg-secondary_light_shades"
            }
            key={element?.id}
          >
            <td className="px-5 py-3 truncate capitalize">
              {element?.type === "service_request"
                ? element?.type.replace("_", " ")
                : element?.type}
            </td>
            <td className="px-5 py-3 truncate">{`$${element?.price} / ${element?.duration}`}</td>
            <td className="px-5 py-3 truncate">
              {element.start_date
                ? moment(element?.start_date).format("DD/MM/YYYY ")
                : ""}
              -
              {element.end_date
                ? moment(element?.end_date).format(" DD/MM/YYYY")
                : ""}
            </td>
            <td className="flex items-center px-5 py-3">
              <Badge
                value={"Over"}
                className={
                  "bg-danger_color border-danger_color text-white text-xs !px-2 !py-0.5"
                }
              />
            </td>
          </tr>
        ))}
      </>
    );
  };
  return (
    <>
      {!isOpen && (
        <div
          className="flex justify-between items-center rounded-lg bg-disable_grey border border-secondary_grey py-3 px-5 cursor-pointer"
          onClick={() => past_subscriptions?.length > 0 && setIsOpen(true)}
        >
          <div className="flex items-center space-x-2 text-sm">
            <p>Past Subscription/Transaction</p>
            <Badge
              value={past_subscriptions?.length}
              className={
                "bg-danger_color border-danger_color text-white text-xs !px-2 !py-0.5"
              }
            />
          </div>
          <div className="flex items-center space-x-2 text-sm">
            <p>Show All</p>
            <button type="button" onClick={() => setIsOpen(!isOpen)}>
              <ExpandLess pathClass={"fill-secondary_lightGrey"} />
            </button>
          </div>
        </div>
      )}
      {isOpen && (
        <div className="w-full bg-white border rounded">
          <CustomTable
            columnHeaders={<ColumnHeaders />}
            dataRows={<DataRows />}
            data={salesList}
            overflowVisibleLg={true}
            // loader
            loading={false}
            showPagination={false}
          />
        </div>
      )}
    </>
  );
};

export default PostSubscription;
